/* tslint:disable */
/* eslint-disable */
/* @relayHash a188b622f158f0d843739325c4c1ebf0 */

import { ConcreteRequest } from "relay-runtime";
export type TabsCoursesQueryVariables = {
    categoryUUID?: string | null;
    secondaryCategoryUUID?: string | null;
    name?: string | null;
};
export type TabsCoursesQueryResponse = {
    readonly courses: {
        readonly edges: ReadonlyArray<{
            readonly ident: number;
            readonly name: string;
            readonly price: number;
            readonly role: string | null;
            readonly marketColor: string | null;
            readonly category: {
                readonly uuid: string | null;
            } | null;
            readonly secondaryCategory: {
                readonly uuid: string | null;
            } | null;
            readonly backgroundCheck: boolean | null;
            readonly specificTerms: string | null;
        } | null> | null;
    } | null;
};
export type TabsCoursesQuery = {
    readonly response: TabsCoursesQueryResponse;
    readonly variables: TabsCoursesQueryVariables;
};



/*
query TabsCoursesQuery(
  $categoryUUID: UUID
  $secondaryCategoryUUID: UUID
  $name: String
) {
  courses(filter: {categoryUUID: $categoryUUID, secondaryCategoryUUID: $secondaryCategoryUUID, name: $name}, page: {limit: 200}, orderBy: {ascending: false, field: "priority"}) {
    edges {
      __typename
      ident: id
      name
      price
      role
      marketColor
      category {
        uuid
      }
      secondaryCategory {
        uuid
      }
      backgroundCheck
      specificTerms
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "categoryUUID",
            "type": "UUID",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "secondaryCategoryUUID",
            "type": "UUID",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "name",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ObjectValue",
            "name": "filter",
            "fields": [
                {
                    "kind": "Variable",
                    "name": "categoryUUID",
                    "variableName": "categoryUUID"
                },
                {
                    "kind": "Variable",
                    "name": "name",
                    "variableName": "name"
                },
                {
                    "kind": "Variable",
                    "name": "secondaryCategoryUUID",
                    "variableName": "secondaryCategoryUUID"
                }
            ]
        } as any),
        ({
            "kind": "Literal",
            "name": "orderBy",
            "value": {
                "ascending": false,
                "field": "priority"
            }
        } as any),
        ({
            "kind": "Literal",
            "name": "page",
            "value": {
                "limit": 200
            }
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": "ident",
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "price",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "role",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "marketColor",
        "args": null,
        "storageKey": null
    } as any), v7 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "uuid",
            "args": null,
            "storageKey": null
        } as any)
    ], v8 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "category",
        "storageKey": null,
        "args": null,
        "concreteType": "Category",
        "plural": false,
        "selections": (v7 /*: any*/)
    } as any), v9 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "secondaryCategory",
        "storageKey": null,
        "args": null,
        "concreteType": "SecondaryCategory",
        "plural": false,
        "selections": (v7 /*: any*/)
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "backgroundCheck",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "specificTerms",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "TabsCoursesQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "courses",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CoursePage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "TabsCoursesQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "courses",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CoursePage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "__typename",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "TabsCoursesQuery",
            "id": null,
            "text": "query TabsCoursesQuery(\n  $categoryUUID: UUID\n  $secondaryCategoryUUID: UUID\n  $name: String\n) {\n  courses(filter: {categoryUUID: $categoryUUID, secondaryCategoryUUID: $secondaryCategoryUUID, name: $name}, page: {limit: 200}, orderBy: {ascending: false, field: \"priority\"}) {\n    edges {\n      __typename\n      ident: id\n      name\n      price\n      role\n      marketColor\n      category {\n        uuid\n      }\n      secondaryCategory {\n        uuid\n      }\n      backgroundCheck\n      specificTerms\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '9766de78de0ec717c79065037b66e1e4';
export default node;
